var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstPageArrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82092 7.5402C8.82092 7.19722 8.70508 6.82495 8.36281 6.80294C8.3409 6.80153 8.31804 6.80078 8.29419 6.80078C8.21718 6.80078 8.14926 6.80566 8.08944 6.81396C7.77827 6.85711 7.67188 7.18079 7.67188 7.49494V16.5314C7.67188 16.828 7.76856 17.1344 8.06149 17.1812C8.12779 17.1918 8.20482 17.1982 8.29419 17.1982C8.31765 17.1982 8.34016 17.1975 8.36175 17.1961C8.7047 17.1744 8.82092 16.8014 8.82092 16.4578V7.5402Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7819 12.0008L16.0823 8.06892C16.3996 7.77881 16.3996 7.30846 16.0823 7.01836C15.765 6.72826 15.2506 6.72826 14.9333 7.01836L10.0583 11.4755C9.74099 11.7656 9.74099 12.236 10.0583 12.5261L14.9333 16.9832C15.2506 17.2733 15.765 17.2733 16.0823 16.9832C16.3996 16.6931 16.3996 16.2227 16.0823 15.9326L11.7819 12.0008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPageArrowPagination);
export default __webpack_public_path__ + "static/media/first-page-arrow-pagination.da6248641f6005056b4ae26b0bd3ae48.svg";
export { ForwardRef as ReactComponent };